import { render, staticRenderFns } from "./BDatepicker.vue?vue&type=template&id=c0533210&scoped=true&"
import script from "./BDatepicker.vue?vue&type=script&lang=js&"
export * from "./BDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./BDatepicker.vue?vue&type=style&index=0&id=c0533210&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0533210",
  null
  
)

export default component.exports